import React from 'react';

// import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import styles from './AccordionList.module.scss';
import Accordion from '../Accordion';
import classNames from 'classnames';

const accordionListDefaultPropItems = [];

const AccordionList = ({ title = '', items = accordionListDefaultPropItems, fromPage }) => {
    if (!items.length) {
        return;
    }

    const rootClasses = classNames(styles['Root'], 'grid', {
        [styles['ReportPage']]: fromPage === 'reportPage',
        [styles['OfferPage']]: fromPage === 'offerPage',
        [styles['CampaignPage']]: fromPage === 'campaignPage',
    });

    return (
        <div className={rootClasses}>
            <div className={styles['Container']}>
                {title && <h2 className={styles['Title']}>{title}</h2>}
                {items.map((item, index) => (
                    <Accordion key={index} {...item} />
                ))}
            </div>
        </div>
    );
};

AccordionList.propTypes = {
    title: PropTypes.string,
    items: PropTypes.array,
};

export default AccordionList;
